import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
export function PasswordChecklist({ rules }) {
    return (_jsx("div", { className: "space-y-1", children: rules.map((rule) => (_jsxs("div", { className: `text-sm ${rule.valid ? "text-emerald-600" : "text-slate-500"}`, children: [rule.valid ? "\u2713" : "\u2022", " ", rule.label] }, rule.id))) }));
}
